import React, { forwardRef } from 'react';
import CustomLabel from 'components/Additional/CustomLabel/CustomLabel';

const CustomInput = forwardRef(
	(
		{
			inputName,
			inputLabel,
			type,
			error,
			tooltip,
			isDisabled = false,
			...rest
		},
		ref
	) => {
		return (
			<div className="flex flex-col gap-2">
				{inputLabel && (
					<CustomLabel label={inputLabel} tooltip={tooltip} />
				)}
				<div className="flex flex-col">
					<input
						name={inputName}
						type={type ?? 'text'}
						className={`w-full py-1.5 md:py-2 px-3 md:px-5 box-border rounded-xl md:rounded-2xl text-base md:text-2xl border border-sfi-blue transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-300/25 disabled:bg-gray-300 disabled:opacity-60 ${
							error ? 'border-sfi-red' : ''
						}`}
						disabled={isDisabled}
						ref={ref}
						{...rest}
					/>
					<span className="text-sfi-red text-xs md:text-sm min-h-[16px] md:min-h-[21px]">
						{error && error}
					</span>
				</div>
			</div>
		);
	}
);

export default CustomInput;
